import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=1a106290&scoped=true"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=1a106290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a106290",
  null
  
)

export default component.exports